import { createSelector } from 'reselect';
import { initialState } from 'containers/Offer/reducer';

const selectQuote = state => state.get('offer', initialState);

const makeSelectQuote = () =>
  createSelector(selectQuote, quoteState => quoteState.get('quote'));

const makeSelectQuotationCode = () =>
  createSelector(selectQuote, quoteState => quoteState.get('quotationCode'));

export { selectQuote, makeSelectQuote, makeSelectQuotationCode };
